import React from "react";

import LungIcon from "../icons/LungIcon";
import { ResultSummarySection } from "./ResultSummarySection";

function RespiratorySummaryMetric({
  label,
  value,
  unit,
  disabled = false,
  showDivider = false,
}) {
  return (
    <div
      data-testid={showDivider ? "resp-summary-divider" : undefined}
      className={[
        "flex min-w-0 flex-col gap-0 px-2",
        showDivider ? "border-l border-greyscale-1" : "pl-0",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label ? <p className="muted-text font-semibold">{label}</p> : null}
      <div className="flex items-end justify-end gap-1">
        <span
          className={[
            "title-text leading-none tabular-nums",
            disabled ? "!text-greyscale-3" : "text-primary",
          ].join(" ")}
        >
          {value}
        </span>
        {unit ? (
          <span className="muted-text mb-0.5 font-semibold leading-none">
            {unit}
          </span>
        ) : null}
      </div>
    </div>
  );
}

export function MultiMetricSummaryRow({
  leadingLabel,
  metrics,
  disabled = false,
}) {
  return (
    <div className="flex w-full items-end justify-between gap-4">
      <div
        className={[
          "result-summary-row-label shrink-0",
          disabled ? "!text-greyscale-3" : "",
        ].join(" ")}
      >
        {leadingLabel}
      </div>

      <div className="flex flex-1 justify-end gap-0">
        {metrics.map((metric, index) => (
          <RespiratorySummaryMetric
            key={`${leadingLabel}-${metric.label}-${index}`}
            label={metric.label}
            value={metric.value}
            unit={metric.unit}
            disabled={metric.disabled ?? disabled}
            showDivider={index > 0}
          />
        ))}
      </div>
    </div>
  );
}

export function MultiMetricSummarySection({
  title,
  icon = <LungIcon />,
  rows = [],
  disabled = false,
  rowDisabled = disabled,
  children = null,
}) {
  return (
    <ResultSummarySection icon={icon} title={title} disabled={disabled}>
      <div className="flex flex-col gap-2 w-full">
        {rows.map((row, index) => (
          <MultiMetricSummaryRow
            key={`${row.leadingLabel}-${index}`}
            leadingLabel={row.leadingLabel}
            metrics={row.metrics}
            disabled={row.disabled ?? rowDisabled}
          />
        ))}
        {children}
      </div>
    </ResultSummarySection>
  );
}

export default function PostExertionRespiratorySummary(props) {
  return <MultiMetricSummarySection {...props} />;
}
